import { render, staticRenderFns } from "./ImageCaption.vue?vue&type=template&id=e5c02c16&"
import script from "./ImageCaption.vue?vue&type=script&lang=ts&"
export * from "./ImageCaption.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports